// extracted by mini-css-extract-plugin
export default {"textButtonSelected":"table_textButtonSelected__EEKqI"};